module.exports = __webpack_public_path__ + "img/mannul_transactions_search.bc97a573.png";